import request from "@/utils/request";

// 获取国家下拉
export function country() {
  return request({
    url: "/user/list/country",
    method: "get",
  });
}

// 获取用户类型下拉
export function userType() {
  return request({
    url: "/user/list/userType",
    method: "get",
  });
}

// 注册
export function register(params) {
  return request({
    url: "/user/register/email",
    method: "post",
    data: params,
  });
}

// 登录
export function login(params) {
  return request({
    url: "/user/login",
    method: "post",
    data: params,
  });
}

// 获取用户详情
export function userDetail() {
  return request({
    url: "/user/detail",
    method: "get",
  });
}

// 验证用户名是否可用
export function checkUserName(params) {
  return request({
    url: "/user/check/username",
    method: "get",
    params: params,
  });
}

// 获取邮箱验证码
export function getEmailCode(params) {
  return request({
    url: "/oauth/captcha/email",
    method: "get",
    params: params,
  });
}

// 校验邮箱验证码
export function checkEmailCode(params) {
  return request({
    url: "/oauth/captcha/advanced-check",
    method: "post",
    data: params,
  });
}

// 修改密码--通过邮箱验证码
export function changePassWord(params) {
  return request({
    url: "/user/password/update/forgot",
    method: "post",
    data: params,
  });
}

// 查询用户列表
export function userList(params) {
  return request({
    url: "/user/search",
    method: "get",
    params: params,
  });
}

// 修改用户角色
export function updateRole(params) {
  return request({
    url: "/user/update/role",
    method: "post",
    data: params,
  });
}

// 修改用户信息
export function updateUser(params) {
  return request({
    url: "/user/update",
    method: "post",
    data: params,
  });
}

// 密码验证
export function validatePassword(params) {
  return request({
    url: "/user/password/authenticate",
    method: "post",
    data: params,
  });
}

// 修改邮箱
export function updateEmail(params) {
  return request({
    url: "/user/update/email",
    method: "post",
    data: params,
  });
}

// 更改密码----通过旧密码验证
export function updatePassword(params) {
  return request({
    url: "/user/password/update",
    method: "post",
    data: params,
  });
}

// 关注/取消关注用户
export function updateFllow(id, method) {
  return request({
    url: "/user/follow/" + id,
    method: method,
  });
}

// 我的关注
export function followingList(params) {
  return request({
    url: "/user/follow/followings",
    method: "get",
    params: params,
  });
}

// 我的粉丝
export function followerList(params) {
  return request({
    url: "/user/follow/followers",
    method: "get",
    params: params,
  });
}

// 获取粉丝、关注总数
export function followStats(params) {
  return request({
    url: "/user/follow/stats",
    method: "get",
    params: params,
  });
}

// 根据uuid查询个人信息
export function infoByUuid(params) {
  return request({
    url: "/user/getUser/uuid",
    method: "get",
    params: params,
  });
}

// 我是否关注了某个用户
export function isFollowByMe(params) {
  return request({
    url: "/user/follow/isFollowing/" + params,
    method: "get",
  });
}

// 更改邮箱展示状态
export function changeEmailStatus(params) {
  return request({
    url: "/user/update/display",
    method: "post",
    data: params,
  });
}

// 统计用户分享/收藏资源的数量
export function userDataStatistics(params) {
  return request({
    url: "/discover/user/favorite/count",
    method: "get",
    params: params,
  });
}

// 查询 OGE 账号绑定状态
export function getOgeAccount() {
  return request({
    url: "/user/oge-account",
    method: "get",
  });
}

// 首次绑定 OGE 账号
export function bindOgeAccount(params) {
  return request({
    url: "/user/oge-account",
    method: "post",
    data: params,
  });
}

// 修改 OGE 账号绑定
export function updateOgeAccount(params) {
  return request({
    url: "/user/oge-account",
    method: "put",
    data: params,
  });
}

// 解绑 OGE 账号
export function unbindOgeAccount() {
  return request({
    url: "/user/oge-account",
    method: "delete",
  });
}

// 获取 OGE 账户凭证
export function getOgeAccountCredentials(params) {
  return request({
    url: "/user/oge-account/credentials",
    method: "post",
    data: params,
    acceptedResponseCodes: [40401],
  });
}
